import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useHttp from "../../../../hooks/use-http";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { AutoComplete } from "antd";

const FarmerInspectionReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
  const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };

  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [employeeAllData, setEmployeeAllData] = useState([]);
  const [regionId, setRegionId] = useState();
  const [farmerNumber, setFarmerNumber] = useState("");
  const [farmerData, setFarmerData] = useState();
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();

  const handleDateFilterChange = (e) => {
    setShowDateFilter(e.target.value === "Yes");
  };

  const [data, setData] = useState([]);

  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    //console.log("handleFDateChange", e.target.value);
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  // var date =date.setDate(date.getDate() + 10);

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 30);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  //console.log("toDate", toDate);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getTemplateData } = useHttp();

  const fillTemplateData = (employeeId) => {
    var urlfilter = "";

    if (showDateFilter) {
      urlfilter = urlfilter + `&fromDate=${selectedFromDate}`;
      urlfilter = urlfilter + `&toDate=${selectedToDate}`;
    }

    if (employeeId > 0) {
      urlfilter = urlfilter + `&fieldExecutiveId=${employeeId}`;
    }

    // if (warehouseId > 0) {
    //   urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    // }

    // if (regionId > 0) {
    //   urlfilter = urlfilter + `&regionId=${regionId}`;
    // }
    // if (farmerNo != "") {
    //   urlfilter = urlfilter + `&farmerNo=${farmerNo}`;
    // }

    var url = `/api/farmerInspectionReport/?orgId=${localStorage.getItem(
      "orgId"
    )}&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getTemplateData(
      {
        url: url,
      },
      (data) => {
        console.log("reportdata", data);
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillTemplateData(0, 0, "");
  }, [getTemplateData]);

  const concatenateDetails = (details, field) => {
    return details.map((detail) => detail[field] || "").join(" \n ");
  };

  const prepareDataForExcel = (tableData) => {
    return tableData.map((item) => {
      const details = item.farmInspectionDetail || [];
      return {
        farmInspectionDate: item.farmInspectionDate
          ? new Date(item.farmInspectionDate).toLocaleDateString("en-GB")
          : "NA",
        docNo: item.docNo,
        supervisorName: item.supervisorName,
        farmerName: item.farmerName,
        plotName: item.plotName,
        cropName: item.cropName,
        dateOfGabPlanting: item.dateOfGabPlanting
          ? new Date(item.dateOfGabPlanting).toLocaleDateString("en-GB")
          : "NA",
        activitiesCarriedOutByFarmer: item.activitiesCarriedOutByFarmer,
        otherRecommendationsComments: item.otherRecommendationsComments,
        farmersRemark: item.farmersRemark,
        complianceHeadName: concatenateDetails(details, "complianceHeadName"),
        complianceFieldName: concatenateDetails(details, "complianceFieldName"),
        controlType: concatenateDetails(details, "controlType"),
        observation: concatenateDetails(details, "observation"),
        justification: concatenateDetails(details, "justification"),
        createdDate: item.createdDate
          ? new Date(item.createdDate).toLocaleDateString("en-GB")
          : "NA",
      };
    });
  };

  const fieldsToExport = [
    "farmInspectionDate",
    "docNo",
    "supervisorName",
    "farmerName",
    "plotName",
    "cropName",
    "dateOfGabPlanting",
    "activitiesCarriedOutByFarmer",
    "otherRecommendationsComments",
    "farmersRemark",
    "complianceHeadName",
    "complianceFieldName",
    "observation",
    "justification",
    "createdDate",
  ];

  const customHeaders = [
    "Inspection Date",
    "Doc No",
    "Executive name",
    "Farmer Name",
    "Plot Name",
    "Crop Variety",
    "Date of Gab Planting",
    "Activities Carried Out By The Farmer During The Visit",
    "Other Recommendation & Comments",
    "Farmer's Remark",
    "Compliance Head Name",
    "Compliance Field Name",
    "observation",
    "justification",
    "Created Date",
  ];

  const preparedData = prepareDataForExcel(data);

  const handleExportExcel = () => {
    const filename = "FarmerInspectionReport.xlsx";
    // console.log(fieldsToExport, customHeaders);

    convertToExcel(preparedData, fieldsToExport, filename, customHeaders);
  };

  //   const { sendRequest: getWarehouseData } = useHttp();

  //   const getWarehouseDetail = () => {
  //     getWarehouseData(
  //       {
  //         url: "/api/warehouses/",
  //       },
  //       (res) => {
  //         if (res) {
  //           setWarehosuedata(res);
  //         }
  //       }
  //     );
  //   };

  //   useEffect(() => {
  //     getWarehouseDetail();
  //   }, [getWarehouseData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = (region) => {
    var urlfilter = "";

    if (region > 0) {
      urlfilter = urlfilter + `&regionId=${region}`;
    }
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")}${urlfilter} `,
      },
      (data) => {
        // console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        //   setEmployeeAllData(emplist);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  // const { sendRequest: getFarmerNumber } = useHttp();
  // useEffect(() => {
  //   getFarmerNumber(
  //     {
  //       url: `/api/farmerNumberList/?orgId=${localStorage.getItem(
  //         "orgId"
  //       )}&fieldExecutiveId=${employeeId}`,
  //     },
  //     (data) => {
  //       console.log("farmerNumberList", data);

  //       setFarmerData(data);
  //     }
  //   );
  // }, [employeeId]);

  // const handleSearch = (value) => {
  //   setFarmerNumber(value);
  // };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title">Farmer Inspection Report</label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Executive Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      var userid = 0;
                      if (e.target.value != "--Select--")
                        userid = e.target.value;

                      setEmployeeId(userid);
                      setData([]);
                    }}
                  >
                    <option value="0">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option
                          key={x.userId}
                          user-id={x.userId}
                          value={x.userId}
                        >
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"date_filter"}>{"Apply Date Filter"}</label>
                  <select
                    id="date_filter"
                    className="form-control"
                    ref={(el) => (frmRef.current["date_filter"] = el)}
                    onChange={handleDateFilterChange}
                  >
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
              {showDateFilter && (
                <>
                  <div className="col-md-3">
                    <div className="form-group">
                      {" "}
                      <label htmlFor={"from_date"}>{"From Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedFromDate}
                        onChange={handleFDateChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="form-group">
                      <label htmlFor={"to_date"}>{"To Date"}</label>

                      <input
                        type={"date"}
                        id={"date"}
                        required
                        // ref={(el) => (frmRef.current["pdate"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedToDate}
                        onChange={handleTDateChange}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="row">
              <div className="col-md-3  text-right">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillTemplateData(employeeId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered table-responsive text-center table-sm">
                      <thead>
                        {(() => {
                          let groupedCompliance = {};

                          if (
                            currentItems &&
                            currentItems.length > 0 &&
                            currentItems[0]?.farmInspectionDetail
                          ) {
                            groupedCompliance =
                              currentItems[0].farmInspectionDetail.reduce((acc, detail) => {
                                const headName = detail.complianceHeadName;

                                if (!acc[headName]) {
                                  acc[headName] = [];
                                }

                                acc[headName].push(detail);

                                return acc;
                              }, {});
                          }

                          return (
                            <>
                              <tr className="table-header">
                                <th rowSpan="3">Sr.No</th>
                                <th rowSpan="3">Inspection Date</th>
                                <th rowSpan="3">Doc No</th>
                                <th rowSpan="3">Executive Name</th>
                                <th rowSpan="3">Farmer Name</th>
                                <th rowSpan="3">Plot Name</th>
                                <th rowSpan="3">Crop Variety</th>
                                <th rowSpan="3">Date of Gab Planting</th>
                                <th rowSpan="3">
                                  Activities Carried Out By The Farmer During The Visit
                                </th>
                                <th rowSpan="3">Other Recommendations & Comments</th>
                                <th rowSpan="3">Farmer's Remark</th>

                                {Object.entries(groupedCompliance).map(
                                  ([headName, fields], index) => (
                                    <th
                                      key={`head-${index}`}
                                      colSpan={fields.length * 2}
                                    >
                                      {headName}
                                    </th>
                                  )
                                )}

                                <th rowSpan="3">Created Date</th>
                              </tr>

                              <tr>
                                {Object.entries(groupedCompliance).map(
                                  ([headName, fields], index) =>
                                    fields.map((field, subIndex) => (
                                      <th
                                        key={`field-${index}-${subIndex}`}
                                        colSpan="2"
                                      >
                                        {field.complianceFieldName}
                                      </th>
                                    ))
                                )}
                              </tr>

                              <tr>
                                {Object.entries(groupedCompliance).map(
                                  ([headName, fields], index) =>
                                    fields.map((field, subIndex) => (
                                      <React.Fragment
                                        key={`sub-${index}-${subIndex}`}
                                      >
                                        <th>Observation</th>
                                        <th>Justification</th>
                                      </React.Fragment>
                                    ))
                                )}
                              </tr>
                            </>
                          );
                        })()}
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((item, index) => (
                            <tr key={`row-${index}`}>
                              {/* Static row values */}
                              <td>{index + 1}</td>
                              <td>{new Date(item.farmInspectionDate).toLocaleDateString()}</td>
                              <td>{item.docNo}</td>
                              <td>{item.supervisorName}</td>
                              <td>{item.farmerName}</td>
                              <td>{item.plotName}</td>
                              <td>{item.cropName}</td>
                              <td>{new Date(item.dateOfGabPlanting).toLocaleDateString()}</td>
                              <td>{item.activitiesCarriedOutByFarmer}</td>
                              <td>{item.otherRecommendationsComments}</td>
                              <td>{item.farmersRemark}</td>

                              {/* Dynamic compliance field values */}
                              {(() => {
                                const allFields =
                                  currentItems[0]?.farmInspectionDetail || [];

                                return allFields.flatMap((headerField, index) => {
                                  const matchedField = item.farmInspectionDetail.find(
                                    (detail) =>
                                      detail.complianceHeadName ===
                                      headerField.complianceHeadName &&
                                      detail.complianceFieldName ===
                                      headerField.complianceFieldName
                                  );

                                  return [
                                    <td
                                      key={`obs-${index}`}
                                      style={{ width: "10%" }}
                                    >
                                      {matchedField?.observation || "N/A"}
                                    </td>,

                                    <td
                                      key={`just-${index}`}
                                      style={{ width: "10%" }}
                                    >
                                      {matchedField?.justification || "N/A"}
                                    </td>,
                                  ];
                                });
                              })()}
                              <td>
                                {new Date(
                                  item.createdDate
                                ).toLocaleDateString()}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerInspectionReport;
